import moment from "moment";
import useTranslator from "../../hooks/useTranslator";
import { getUserDisplayName, haveValue } from "../../helper/common";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import LandLordContext from "../../context/landlord/LandLordContext";
import { DownloadIcon } from "../../helper/svgHelper";
import LoadingSpinner from "../LoadingSpinner";

const CreditsRow = ({ data }) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { workspaceId } = useParams();
  const { getCreditInvoice } = useContext(LandLordContext);
  const [loadingInvoice, setLoadingInvoice] = useState(false);

  const handleOpenProfile = () => {
    navigate(
      `/${workspaceId}/profile-property?sharedprofileid=${data?.opened_profile_id?._id}`
    );
  };

  const handleDownloadInvoice = async () => {
    setLoadingInvoice(true);
    try {
      const response = await getCreditInvoice(data?._id);
      if (response?.success && response?.success_res?.invoice_url) {
        const invoiceUrl = `${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${response.success_res.invoice_url}`;
        window.open(invoiceUrl, "_blank");
      }
    } catch (err) {
      console.error("Error downloading invoice:", err);
    } finally {
      setLoadingInvoice(false);
    }
  };
  return (
    <>
      <tr className={`second-row relative`}>
        <td className="text-capitalize">{_t(data?.type) ?? "-"}</td>
        <td className="">{data?.credit ?? "-"}</td>
        <td className="">{data?.amount ?? "-"}</td>
        <td className="">{_t(data?.status) ?? "-"}</td>
        <td
          onClick={
            haveValue(data?.opened_profile_id?._id)
              ? handleOpenProfile
              : () => {}
          }
          className={`${
            data?.opened_profile_id?._id ? "underline cursor-pointer" : ""
          }`}
        >
          {getUserDisplayName(data?.opened_profile_id?.tenant_id, "-")}
        </td>
        <td>
          {data?.landlord_id?.fname_companyName ?? "-"}{" "}
          {data?.landlord_id?.lname}
        </td>
        <td className="">
          {data?.processing_date
            ? moment(data.processing_date).format("DD MMMM YYYY, HH:mm:ss")
            : "-"}
        </td>
        <td className="credits-row__invoice-cell">
          {data?.status === "pending" ||
          data?.type !== "credit" ||
          data?.metadata?.source === "admin_add_credit" ? (
            "-"
          ) : loadingInvoice ? (
            <LoadingSpinner size={16} color="#253837" borderWidth={2} />
          ) : (
            <span
              onClick={handleDownloadInvoice}
              title="Download Invoice"
              className="credits-row__download-btn"
            >
              <DownloadIcon />
            </span>
          )}
        </td>
      </tr>
    </>
  );
};

export default CreditsRow;
